import { render, staticRenderFns } from "./ContentDirectory.vue?vue&type=template&id=63735b83&lang=html&"
import script from "./ContentDirectory.vue?vue&type=script&lang=ts&"
export * from "./ContentDirectory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports